import { ENTER_SUPPORT_CONTEXT, LEAVE_SUPPORT_CONTEXT } from "../constant";
import { saveSupportContext } from "../supportContextStorage";

export const enterSupportContext = (org) => (dispatch) => {
  const payload = {
    _id: String(org._id),
    username: org.username || "",
    email: org.email || "",
  };
  saveSupportContext(payload);
  dispatch({ type: ENTER_SUPPORT_CONTEXT, payload });
};

export const leaveSupportContext = () => (dispatch) => {
  saveSupportContext(null);
  dispatch({ type: LEAVE_SUPPORT_CONTEXT });
};
